var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "125",
        height: "125",
        viewBox: "0 0 512 512",
      },
    },
    [
      _c("circle", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "32px",
        },
        attrs: { cx: "176", cy: "416", r: "16" },
      }),
      _vm._v(" "),
      _c("circle", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "32px",
        },
        attrs: { cx: "400", cy: "416", r: "16" },
      }),
      _vm._v(" "),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "32px",
        },
        attrs: { points: "48 80 112 80 160 352 416 352" },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "32px",
        },
        attrs: {
          d: "M160,288H409.44a8,8,0,0,0,7.85-6.43l28.8-144a8,8,0,0,0-7.85-9.57H128",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }